import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  FormContainer,
  NextButton,
  Prompt,
  QuestionContainer,
  QuestionPageContainer,
  Scale,
  ScaleInput,
} from "~/OnboardingApp/components";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";
import { useSubmitOnboardingQuestion } from "~/OnboardingApp/hooks/useSubmitOnboardingQuestion";
import { requiredString } from "~/utils/validations";

type Values = {
  clinicSatisfaction: Scale;
};

const validationSchema = Yup.object({
  clinicSatisfaction: requiredString,
});

export const ClinicSatisfactionPage: FC = () => {
  const { t } = useTranslation();
  const { clinicSatisfaction } = useOnboarding();
  const { onSubmit } = useSubmitOnboardingQuestion();

  const initialValues: Values = {
    clinicSatisfaction: clinicSatisfaction || "",
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
  });

  return (
    <QuestionPageContainer>
      <FormContainer formik={formik}>
        <QuestionContainer>
          <Prompt question={t("onboarding.clinicSatisfactionPage.question")} />

          <ScaleInput
            autoAdvance
            defaultValue={clinicSatisfaction}
            id="clinicSatisfaction"
            scalePath="onboarding.clinicSatisfactionPage"
          />
        </QuestionContainer>

        <NextButton showButton={!!clinicSatisfaction} />
      </FormContainer>
    </QuestionPageContainer>
  );
};
